import type { ThemeOptions } from "@mui/material/styles";

interface ThemePreset {
  swatchColor: string;
  palette: ThemeOptions["palette"];
}

export const THEME_PRESETS = {
  green: {
    swatchColor: "#4E7944",
    palette: {
      mode: "light",
      primary: {
        main: "#4E7944",
        light: "#BADAB3",
        dark: "#3A5733",
        contrastText: "#FFFFFF",
      },
      secondary: {
        main: "#EB8F47",
      },
      background: {
        default: "#F0F3EF",
        paper: "#FFFFFF",
      },
      text: {
        primary: "#262626",
        secondary: "#666666",
      },
      divider: "#E5E5E5",
      warning: {
        main: "#FFFBE1",
        dark: "#663c00",
        contrastText: "#755E02",
      },
      error: {
        main: "#B64F64",
        light: "#FCEBEE",
        dark: "#611a15",
        contrastText: "#FFFFFF",
      },
      success: {
        main: "#2e7d32",
        light: "#edf7ed",
        dark: "#1e4620",
        contrastText: "#FFFFFF",
      },
      info: {
        main: "#262626",
        light: "#A0A099",
        dark: "#9E9E9E",
        contrastText: "#262626",
      },
    },
  },
  orange: {
    swatchColor: "#E67E22",
    palette: {
      mode: "light",
      primary: {
        main: "#E67E22",
        contrastText: "#FFFFFF",
      },
      secondary: {
        main: "#2C3E50",
      },
      background: {
        default: "#FFFFFF",
        paper: "#F5F5F5",
      },
    },
  },
  light: {
    swatchColor: "#FAFAFA",
    palette: {
      mode: "light",
      primary: {
        main: "#424242",
        contrastText: "#FFFFFF",
      },
      secondary: {
        main: "#757575",
      },
      background: {
        default: "#FFFFFF",
        paper: "#F9F9F9",
      },
      divider: "#E5E5E5",
      warning: {
        main: "#FFFBE1",
        dark: "#663c00",
        contrastText: "#755E02",
      },
      error: {
        main: "#B64F64",
        light: "#FCEBEE",
        dark: "#611a15",
        contrastText: "#FFFFFF",
      },
      success: {
        main: "#2e7d32",
        light: "#edf7ed",
        dark: "#1e4620",
        contrastText: "#FFFFFF",
      },
      info: {
        main: "#262626",
        light: "#A0A099",
        dark: "#9E9E9E",
        contrastText: "#262626",
      },
    },
  },
  dark: {
    swatchColor: "#212121",
    palette: {
      mode: "dark",
      primary: {
        main: "#E0E0E0",
        contrastText: "#212121",
      },
      secondary: {
        main: "#B0B0B0",
      },
      background: {
        default: "#212121",
        paper: "#2C2C2C",
      },
    },
  },
} as const satisfies Record<string, ThemePreset>;

export type ThemeName = keyof typeof THEME_PRESETS;

export const THEME_LABELS: Record<ThemeName, string> = {
  green: "Green",
  orange: "Orange",
  light: "Light",
  dark: "Dark",
};
